module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title30"
    }
  }, [_c('h1', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title30"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783408467_fm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRUE CRIME FROM WHARNCLIFFE")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781783408467_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781783408467_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781783408467_ack01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783408467_fm02"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introduction")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("John Paul Jones and the Whitehaven Raid 1778")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forced Marriage and False Imprisonment 1788")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 3")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Keswick Imposter 1802")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Charles Samuel Cave, the Swindler 1824")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Death of a Solway Smuggler 1825")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Firing on the Mob 1826")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Sarah Fox and the Poisoned Coffee 1826")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Mysterious Death of Barnaby Burns 1834")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 9")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Rampant Curate of Rampside 1835")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 10")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Razor-grinder’s Wife 1844")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 11")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Old Hutton Matricide 1845")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 12")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Killing of the Governor of the House of Correction 1845")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 13")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Motiveless Murder of Joseph Jackson 1848")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 14")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Beckhouse Farm Murder 1860")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 15")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Trades Union Murder 1865")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 16")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Navvies’ Punch-up 1870")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 17")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Unsolved Murder of Lucy Sands 1882")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 18")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Hugh Grant, Child Killer 1882")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 19")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Monocled Mutineer 1920")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408467_c20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 20")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Borrowdale Garrotting 1928")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_biblio",
    attrs: {
      "href": "#/e9781783408467_bib01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bibliography")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781783408467_ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fefd4eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408467_toc01.vue
// module id = 66
// module chunks = 0